import { ValueOf } from '../utilities/types';

const resourceTypes = {
  ACCOUNT: 'Account',
  ACCOUNT_ENTITY: 'AccountEntity',
  ANALYSIS: 'Analysis',
  API_KEY: 'ApiKey',
  BUSINESS: 'Business',
  CAR: 'Car',
  CASE: 'Case',
  CASE_TRANSACTION_SNAPSHOT: 'CaseTransactionSnapshot',
  CONNECTION: 'Connection',
  DATA_POINT: 'DataPoint',
  FORM: 'Form',
  GROUP: 'Group',
  INDIVIDUAL: 'Individual',
  KYCFORM: 'KycForm',
  MEMBER: 'Member',
  PERMISSION_ROLE: 'PermissionRole',
  PING: 'Ping',
  PROCESS: 'Process',
  PRODUCT: 'Product',
  REPORT: 'Report',
  REQUEST: 'Request',
  REVIEW: 'Review',
  RISK_CLASS: 'RiskClass',
  RULE: 'Rule',
  RULE_VERSION: 'RuleVersion',
  SERVICE: 'Service',
  SIGNAL: 'Signal',
  TAG: 'Tag',
  TEAM: 'Team',
  TRANSACTION_TYPE: 'TransactionType',
  TRANSACTION_TABLE_SETUP: 'TransactionTableSetup',
} as const;

export type ResourceTypes = ValueOf<typeof resourceTypes>;

export default resourceTypes;
